export default ($api) => ({
  uploadFile: (data) => {
    return $api.post(`upload-single-file`, data)
  },
})
